import Auth from '../../methods/Auth';
import user from '../../images/user.svg';

export default function Profile() {
    return (
      <div className="profile-page">
        <h4>Profile</h4>
        <ef-layout className="profile-layout" flex>
          <ef-layout size="150px">
            <img src={Auth.currentUser.photo ? Auth.currentUser.photo : user} alt="Profile"/>
          </ef-layout>
          <ef-layout>
            <h3>Personal Information</h3>
            <div className='userinfo-div'><span className='userinfo-span2'>First Name</span><span className='userinfo-span'>{Auth.currentUser.name[0]}</span></div>
            <div className='userinfo-div'><span className='userinfo-span2'>Last Name</span><span className='userinfo-span'>{Auth.currentUser.name[1]}</span></div>
            <div className='userinfo-div'><span className='userinfo-span2'>Employee ID</span><span className='userinfo-span'>{Auth.currentUser.trid}</span></div>
            <div className='userinfo-div'><span className='userinfo-span2'>Email</span><span className='userinfo-span'>{Auth.currentUser.email}</span></div>
            <div className='userinfo-div'><span className='userinfo-span2'>Role</span><span className='userinfo-span'>{Auth.role}</span></div>
          </ef-layout>
        </ef-layout>
      </div>
    );
}